var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31 -160H263V119C263 123.418 259.418 127 255 127H-23C-27.4183 127 -31 123.418 -31 119V-160Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -8,
    width: 204,
    height: 32,
    rx: 16,
    fill: "#FFE7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C4.4087 12.5 2.88258 11.8679 1.75736 10.7426C0.632141 9.61742 0 8.0913 0 6.5C0 4.9087 0.632141 3.38258 1.75736 2.25736C2.88258 1.13214 4.4087 0.5 6 0.5V12.5Z",
    fill: "#FF6007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.913 1.882C8.51906 2.13378 9.06981 2.50207 9.534 2.966L10.24 2.26C9.68304 1.70325 9.02221 1.26123 8.295 0.959L7.913 1.882Z",
    fill: "#FF6007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.0002 5.71223 11.8444 4.93222 11.5415 4.205L10.618 4.587C10.8704 5.19318 11.0003 5.84336 11 6.5H12Z",
    fill: "#FF6007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.944 9.54673L8.11196 9.78343L8.04636 10.0968L8.40637 10.1653C8.64157 10.223 8.68797 10.3104 8.63677 10.5521L8.04636 13.4122C7.89116 14.152 8.13036 14.5 8.69277 14.5C9.12878 14.5 9.63519 14.2922 9.8648 14.0068L9.9352 13.6637C9.7752 13.8089 9.54159 13.8666 9.38639 13.8666C9.16638 13.8666 9.08638 13.7074 9.14318 13.427L9.944 9.54673ZM10 7.82472C10 8.04345 9.91571 8.25322 9.76568 8.40788C9.61565 8.56255 9.41216 8.64944 9.19998 8.64944C8.98781 8.64944 8.78432 8.56255 8.63429 8.40788C8.48426 8.25322 8.39997 8.04345 8.39997 7.82472C8.39997 7.60599 8.48426 7.39622 8.63429 7.24155C8.78432 7.08689 8.98781 7 9.19998 7C9.41216 7 9.61565 7.08689 9.76568 7.24155C9.91571 7.39622 10 7.60599 10 7.82472Z",
    fill: "#FF6007"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 287,
    fill: "white",
    transform: "translate(-31 -160)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.e850eeadb850dea4bfb62cbbec54fbd4.svg";
export { ForwardRef as ReactComponent };